import { hocHook } from "../../../@hoc/hoc-hook";
import { AboutPage } from "./about";

export default hocHook(AboutPage);
